var $ = require('jquery');
var config = (function (props) {
                        var self = {};
                        var _getByPropPath = function (o, s) {
                            // http://stackoverflow.com/a/6491621
                            s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
                            s = s.replace(/^\./, '');           // strip a leading dot
                            var a = s.split('.');
                            for (var i = 0, n = a.length; i < n; ++i) {
                                var k = a[i];
                                if (k in o) {
                                    o = o[k];
                                } else {
                                    return;
                                }
                            }
                            return o;
                        };

                        self.get = function (a) {
                            return _getByPropPath(props, a);
                        };

                        return self;
                    })({"Client":{"fadeInterval":500,"dataTables":{"fixedHeader":{"header":true,"footer":false},"ordering":true,"paging":true,"processing":true,"scrollX":true,"scrollY":true,"language":{"paginate":{"first":"先頭へ","previous":"前へ","next":"次へ","last":"最後へ"},"aria":{"paginate":{"first":"先頭へ","previous":"前へ","next":"次へ","last":"最後へ"}},"decimal":",","thousands":",","emptyTable":"対象データなし","lengthMenu":"<select><option value='10'>10件</option><option value='50'>50件</option><option value='100'>100件</option><option value='200'>200件</option><option value='-1'>全て</option></select>表示","loadingRecords":"Now Loading...","processing":"Now Processing...","search":"全文検索：","searchPlaceholder":"検索ワード","zeroRecords":"対象データなし","info":"_PAGE_ / _PAGES_ ページを表示中","infoEmpty":"対象データなし","infoFiltered":"(全_MAX_件からフィルタリング中)"}}}});;
var error = require('../error');
var notice = require('../notice');
var confirm = require('../confirm');
var i18n = require('../i18n');
var $dom = $('#template-role');

module.exports = {
  show: show,
  hide: hide
}

function show() {
  return new Promise(function(resolve, reject) {
    Promise.resolve()
      .then(setTable)
      .then(refreshList)
      .then(eventBind)
      .then(function() {
        $dom.fadeIn(config.get('Client.fadeInterval')).promise().done(resolve);
      })
      .catch(reject)
    ;
  });
}

function hide() {
  return new Promise(function(resolve, reject) {
    Promise.resolve()
      .then(eventUnBind)
      .then(function() {
        $dom.fadeOut(config.get('Client.fadeInterval')).promise().done(resolve);
      })
      .catch(reject)
    ;
  });
}

function eventBind() {
  return new Promise(function(resolve, reject) {
    $dom.on('click', '.btn-role-add', function(e) {
      Promise.resolve()
        .then(initModal)
        .then(styleSetup)
        .then(showModal)
      ;
    });

    $dom.on('switchChange.bootstrapSwitch', function(e, state) {
      $(e.target).val((state) ? 'on' : undefined);
    });

    $dom.find('#template-role-modal').on('show.bs.modal', function(e) {
    });

    $dom.find('#template-role-modal').on('hidden.bs.modal', function(e) {
    });

    $dom.on('click', '.btn-role-post', function(e) {
      var data = $dom.find('.template-role-form').serialize();
      Promise.resolve(data)
        .then(postData)
        .then(function() {
          return notice.success(i18n.get('dsp.success'));
        })
        .then(hideModal)
        .then(refreshList)
        .catch(showModalMessage)
      ;
    });

    $dom.on('click', '.btn-role-put', function(e) {
      // for getting serialized data, control abled for a moment
      $dom.find('[name=name]').prop('disabled', false);
      var data = $dom.find('.template-role-form').serialize();
      $dom.find('[name=name]').prop('disabled', true);

      Promise.resolve(data)
        .then(putData)
        .then(function() {
          return notice.success(i18n.get('dsp.success'));
        })
        .then(hideModal)
        .then(refreshList)
        .catch(showModalMessage)
      ;
    });


    $dom.on('click', '.btn-edit', function(e) {
      var data = JSON.parse($(e.target).closest('tr').attr('data-json'));
      Promise.resolve({data: data})
        .then(initModal)
        .then(styleSetup)
        .then(showModal)
      ;
    });

    $dom.on('click', '.btn-delete', function(e) {
      var data = JSON.parse($(e.target).closest('tr').attr('data-json'));
      Promise.resolve({data: data})
        .then(confirm.confirm)
        .then(function(data) {
          Promise.resolve(data)
            .then(deleteData)
            .then(refreshList)
            .catch(error.show)
          ;
        })
        .catch(function() {
          // cancel
        });
    });

    resolve();
  });
}

function eventUnBind() {
  return new Promise(function(resolve, reject) {
    $dom.off('click', '.btn-role-add');
    $dom.find('#template-role-modal').off('show.bs.modal');
    $dom.find('#template-role-modal').off('hidden.bs.modal');
    $dom.off('click', '.btn-role-post');
    $dom.off('click', '.btn-role-put');
    $dom.off('click', '.btn-edit');
    $dom.off('click', '.btn-delete');
    $dom.off('switchChange.bootstrapSwitch');
    resolve();
  });
}

function setTable() {
  return new Promise(function(resolve, reject) {

    var table = $('<table></table>');

    table
      .addClass('table table-striped table-bordered table-hover')
      .append(
        $('<thead></thead>')
          .append(
            $('<tr></tr>')
              .append($('<th></th>').text('id').hide())
              .append($('<th></th>')
                .text(i18n.get('dsp.control.role.name'))
                .css('min-width', '200px')
              )
              .append($('<th></th>').text(i18n.get('dsp.control.role.fullName')))
              //.append($('<th></th>').text(i18n.get('dsp.control.role.isAdmin')))
              //.append($('<th></th>').text(i18n.get('dsp.control.role.isManager')))
              .append($('<th></th>')
                .text(i18n.get('dsp.control.action'))
                .css('min-width', '250px')
              )
          )
      )
      .append(
        $('<tbody></tbody>')
      )
    ;

    $dom.find('.rolelist')
      .empty()
      .append(table);

    resolve();
  });

}

function setTableRow(json) {
  return new Promise(function(resolve, reject) {
    var $tbody = $dom.find('.rolelist').find('tbody');

    $tbody
      .empty();

    $.each(json, function(index, role) {
      var row = $('<tr></tr>');

      row
        .addClass((role.isAdmin) ? 'danger' : '')
        .addClass((role.isManager) ? 'warning' : '')
        .attr('data-json', JSON.stringify(role))
        .append($('<td></td>').text(role._id).hide())
        .append($('<td></td>').text(role.name))
        .append($('<td></td>').text(role.fullName))
        //.append($('<td></td>').text((role.isAdmin) ? "yes" : "no"))
        //.append($('<td></td>').text((role.isManager) ? "yes" : "no"))
        .append($('<td></td>').append([
          $('<button></button>')
            .addClass('btn btn-primary btn-edit')
            .text(i18n.get('dsp.control.button.edit')),
          $('<span></span>').html('&nbsp'),
          $('<button></button>')
            .addClass('btn btn-primary btn-delete')
            .text(i18n.get('dsp.control.button.delete'))
        ]))
      ;

      $tbody
        .append(row);

    });

    resolve();

  });
}

function getData() {
  return new Promise(function(resolve, reject) {
    $.ajax({
      type: 'get',
      url: '/local/api/roles',
      success: resolve,
      error: function(xhr) {
        if (xhr.status == 401) {
          throw new error.UnAuthorizedException();
        }
        reject(new error.AjaxException(xhr));
      }
    });
  });
}

function postData(data) {
  return new Promise(function(resolve, reject) {
    $.ajax({
      type: 'post',
      url: '/local/api/roles',
      data: data,
      success: resolve,
      error: function(xhr) {
        if (xhr.status == 401) {
          throw new error.UnAuthorizedException();
        }
        if (xhr.status == 403) {
          throw new error.ForbiddenException();
        }
        if (xhr.status == 400) {
          reject(new error.AjaxValidateException(xhr));
        }
        reject(new error.AjaxException(xhr));
      }
    });
  });
}

function putData(data) {
  return new Promise(function(resolve, reject) {
    $.ajax({
      type: 'put',
      url: '/local/api/roles',
      data: data,
      success: resolve,
      error: function(xhr) {
        if (xhr.status == 401) {
          throw new error.UnAuthorizedException();
        }
        if (xhr.status == 403) {
          throw new error.ForbiddenException();
        }
        if (xhr.status == 400) {
          reject(new error.AjaxValidateException(xhr));
        }
        reject(new error.AjaxException(xhr));
      }
    });
  });
}

function deleteData(param) {
  return new Promise(function(resolve, reject) {
    $.ajax({
      type: 'delete',
      url: '/local/api/roles',
      data: param.data,
      success: resolve,
      error: function(xhr) {
        if (xhr.status == 401) {
          throw new error.UnAuthorizedException();
        }
        if (xhr.status == 403) {
          throw new error.ForbiddenException();
        }
        if (xhr.status == 400) {
          reject(new error.AjaxValidateException(xhr));
        }
        reject(new error.AjaxException(xhr));
      }
    });
  });
}


function showModal(param) {
  return new Promise(function(resolve, reject) {
    var $modal = $dom.find('#template-role-modal');

    if (param && param.data && param.data._id) {
      // put mode
      $modal.find('.btn-role-put').show();
      $modal.find('.btn-role-post').hide();
      $modal.find('[name=_id]').val(param.data._id);
      $modal.find('[name=name]').prop('disabled', true).val(param.data.name);
      $modal.find('[name=fullName]').val(param.data.fullName);
      if (param.data.isAdmin) {
        $modal.find('[name="isAdmin"]').bootstrapSwitch('state', true, true);
      } else {
        $modal.find('[name="isAdmin"]').bootstrapSwitch('state', false, false);
      }
      if (param.data.isManager) {
        $modal.find('[name="isManager"]').bootstrapSwitch('state', true, true);
      } else {
        $modal.find('[name="isManager"]').bootstrapSwitch('state', false, false);
      }

    } else {
      // post mode
      $modal.find('.btn-role-put').hide();
      $modal.find('.btn-role-post').show();
      $modal.find('[name=name]').prop('disabled', false);
      $modal.find('[name="isAdmin"]').bootstrapSwitch('state', false, false);
      $modal.find('[name="isManager"]').bootstrapSwitch('state', false, false);
    }

    $modal.modal({});
    resolve(param);
  });
}

function initModal(param) {
  return new Promise(function(resolve, reject) {
    var $modal = $dom.find('#template-role-modal');
    $modal.find('input').val('');
    $modal.find('.alert').remove();

    resolve(param);
  });
}

function hideModal(param) {
  return new Promise(function(resolve, reject) {
    var $modal = $dom.find('#template-role-modal');
    $modal.modal('hide');
    resolve(param);
  });
}

function showModalMessage(err) {
  return new Promise(function(resolve, reject) {
    var $modal = $dom.find('#template-role-modal');
    $modal.find('.alert').remove();

    var $alert = $('<div></div>');
    $alert
      .addClass('alert alert-warning')
      .attr('role', 'alert')
      .text(err.message)
    ;

    $modal.find('.modal-header').prepend($alert);

    resolve();
  });
}


function refreshList() {
  return new Promise(function(resolve, reject) {
    Promise.resolve()
      .then(getData)
      .then(setTableRow)
      .then(resolve)
      .catch(reject)
    ;
  });
}

function styleSetup(param) {
  return new Promise(function(resolve, reject) {
    $dom.find('[type="checkbox"]').bootstrapSwitch();
    resolve(param);
  });
}

